export type CountriesOptions = {
  highlighted: CountryOption[];
  all: CountryOption[];
};

export type CountryOption = {
  value: number;
  label: string;
};

type Country = {
  id: number;
  name: string;
};

type CountriesResponse = {
  highlighted: Country[];
  all: Country[];
};

class CountryService {
  getAll = () => serviceHttpGetFactory<CountriesResponse>('/apps/nationalities');
}

export const nationalitiesService = new CountryService();

export const getCountriesForLocale = async (locale: string): Promise<CountriesOptions> => {
  const result = await nationalitiesService.getAll();

  if (!result.isSuccess) {
    console.error(
      'Failed to fetch nationalities from API, falling back to local data:',
      result.message,
    );
    return { highlighted: [], all: [] };
  }

  const all = result.data.all.map(
    (nationality: Country): CountryOption => ({
      value: nationality.id,
      label: nationality.name,
    }),
  );

  const highlighted = result.data.highlighted.map(
    (nationality: Country): CountryOption => ({
      value: nationality.id,
      label: nationality.name,
    }),
  );

  return { all: all, highlighted: highlighted };
};
